import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-star-layer-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="star-layer">
      <svg
        class="star" 
        *ngFor="let item of stars" 
        width="40px" 
        height="40px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M12 3L14.0357 8.16153C14.2236 8.63799 14.3175 8.87622 14.4614 9.0771C14.5889 9.25516 14.7448 9.41106 14.9229 9.53859C15.1238 9.68245 15.362 9.77641 15.8385 9.96432L21 12L15.8385 14.0357C15.362 14.2236 15.1238 14.3175 14.9229 14.4614C14.7448 14.5889 14.5889 14.7448 14.4614 14.9229C14.3175 15.1238 14.2236 15.362 14.0357 15.8385L12 21L9.96432 15.8385C9.77641 15.362 9.68245 15.1238 9.53859 14.9229C9.41106 14.7448 9.25516 14.5889 9.0771 14.4614C8.87622 14.3175 8.63799 14.2236 8.16153 14.0357L3 12L8.16153 9.96432C8.63799 9.77641 8.87622 9.68245 9.0771 9.53859C9.25516 9.41106 9.41106 9.25516 9.53859 9.0771C9.68245 8.87622 9.77641 8.63799 9.96432 8.16153L12 3Z"
            stroke="#ffd900"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
  `,
  styles: `
    .star-layer {
      position: fixed;
      inset: 0;
      z-index: 9;
      background: rgba(0, 0, 0, 0.5);
      overflow: hidden;
      pointer-events: none;
    }

    .star-layer .star {
      position: absolute;
      color: #ffd900;
      font-size: 10px;
      opacity: 0;
      animation: twinkle 2s infinite ease-in-out;
      text-shadow: 0 0 6px gold, 0 0 12px gold;
    }

    .star-layer .star:nth-child(1) { top: 5%; left: 15%; animation-delay: 0s; }
    .star-layer .star:nth-child(2) { top: 20%; left: 80%; animation-delay: 1s; }
    .star-layer .star:nth-child(3) { top: 35%; left: 40%; animation-delay: 0.5s; }
    .star-layer .star:nth-child(4) { top: 50%; left: 10%; animation-delay: 1.5s; }
    .star-layer .star:nth-child(5) { top: 65%; left: 75%; animation-delay: 0.3s; }
    .star-layer .star:nth-child(6) { top: 80%; left: 30%; animation-delay: 1.2s; }
    .star-layer .star:nth-child(7) { top: 10%; left: 55%; animation-delay: 0.7s; }
    .star-layer .star:nth-child(8) { top: 45%; left: 60%; animation-delay: 1.8s; }
    .star-layer .star:nth-child(9) { top: 70%; left: 20%; animation-delay: 0.9s; }
    .star-layer .star:nth-child(10) { top: 90%; left: 90%; animation-delay: 1.4s; }
    .star-layer .star:nth-child(11) { top: 15%; left: 35%; animation-delay: 0.2s; }
    .star-layer .star:nth-child(12) { top: 25%; left: 65%; animation-delay: 1.6s; }
    .star-layer .star:nth-child(13) { top: 55%; left: 50%; animation-delay: 0.8s; }
    .star-layer .star:nth-child(14) { top: 75%; left: 85%; animation-delay: 1.1s; }
    .star-layer .star:nth-child(15) { top: 85%; left: 5%; animation-delay: 0.4s; }

    .star-layer .star:nth-child(odd) {
      font-size: 14px;
    }

    @keyframes twinkle {
      0%,
      100% {
        opacity: 0;
        transform: rotate(45deg) scale(0.9);
      }
      50% {
        opacity: 1;
        transform: rotate(180deg) scale(2);
      }
    }
  `,
})
export class StarLayerOverlayComponent {
  stars = Array.from({ length: 15 }, (_, i) => i + 1);
}
